// Simple i18n
import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  de: {
    dashboard: "Dashboard",
    users: "Mitarbeiter",
    locations: "Standorte",
    timeclock: "Zeiterfassung",
    schedules: "Dienstplan",
    shift_exchange: "Schichttausch",
    personnel: "Personaleinsatzplan",
    absences: "Abwesenheiten",
    handover: "Übergabebuch",
    announcements: "Schwarzes Brett",
    surveys: "Umfragen",
    tasks: "Aufgaben",
    qm: "QM-Dokumente",
    chat: "Chat",
    delivery: "Botendienst",
    recipes: "Rezepturen",
    audit: "Aktivitäts-Logs",
    branding: "Branding",
    reports: "Berichte",
    profile: "Profil",
    requests: "Anträge",
    admin_timeclock: "Zeiterfassung (Alle)",
    logout: "Abmelden",
    login: "Anmelden",
    username: "Benutzername",
    password: "Passwort",
    welcome: "Willkommen",
    kiosk: "Kiosk-Modus",
    settings: "Einstellungen",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    create: "Erstellen",
    new: "Neu",
    close: "Schließen",
    search: "Suchen",
    today: "Heute",
    week: "Woche",
    month: "Monat",
    clock_in: "Kommen",
    clock_out: "Gehen",
    break_start: "Pause an",
    break_end: "Pause aus",
    overtime: "Überstunden",
    vacation: "Urlaub",
    sick: "Krank",
    remaining: "Verbleibend",
    used: "Genommen",
    week_hours: "Wochenstunden",
    month_hours: "Monatsstunden",
    next_shift: "Nächste Schicht",
    open_tasks: "Offene Aufgaben",
    add_user: "Mitarbeiter hinzufügen",
    add_location: "Standort hinzufügen",
    weekly_hours: "Wochenstunden (Soll)",
    daily_hours: "Soll-Stunden pro Wochentag",
    pin: "PIN",
    role: "Rolle",
    position: "Position",
    buffer: "Puffer (Min.)",
    active: "Aktiv",
    inactive: "Inaktiv",
    all_locations: "Alle Standorte",
    request_leave: "Urlaub beantragen",
    approve: "Genehmigen",
    reject: "Ablehnen",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    priority: "Priorität",
    normal: "Normal",
    important: "Wichtig",
    urgent: "Dringend",
    title: "Titel",
    content: "Inhalt",
    read_confirm: "Gelesen",
    send: "Senden",
    message: "Nachricht",
    system_name: "Systemname",
    logo: "Logo",
    imprint: "Impressum",
    privacy: "Datenschutz",
    terms: "AGB",
    dark_mode: "Dark Mode",
    light_mode: "Light Mode",
    language: "Sprache",
    export_csv: "CSV Export",
    export_xlsx: "Excel Export",
    export_pdf: "PDF Export",
    footer_text: "Made with",
    footer_by: "by",
  },
  en: {
    dashboard: "Dashboard",
    users: "Employees",
    locations: "Locations",
    timeclock: "Time Clock",
    schedules: "Schedule",
    shift_exchange: "Shift Exchange",
    personnel: "Personnel Plan",
    absences: "Absences",
    handover: "Handover Book",
    announcements: "Bulletin Board",
    surveys: "Surveys",
    tasks: "Tasks",
    qm: "QM Documents",
    chat: "Chat",
    delivery: "Delivery",
    recipes: "Recipes",
    audit: "Audit Log",
    branding: "Branding",
    reports: "Reports",
    profile: "Profile",
    requests: "Requests",
    admin_timeclock: "Time Clock (All)",
    logout: "Log out",
    login: "Sign in",
    username: "Username",
    password: "Password",
    welcome: "Welcome",
    kiosk: "Kiosk Mode",
    settings: "Settings",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    new: "New",
    close: "Close",
    search: "Search",
    today: "Today",
    week: "Week",
    month: "Month",
    clock_in: "Clock in",
    clock_out: "Clock out",
    break_start: "Start break",
    break_end: "End break",
    overtime: "Overtime",
    vacation: "Vacation",
    sick: "Sick",
    remaining: "Remaining",
    used: "Used",
    week_hours: "Week hours",
    month_hours: "Month hours",
    next_shift: "Next shift",
    open_tasks: "Open tasks",
    add_user: "Add employee",
    add_location: "Add location",
    weekly_hours: "Weekly hours (target)",
    daily_hours: "Target hours per weekday",
    pin: "PIN",
    role: "Role",
    position: "Position",
    buffer: "Buffer (min)",
    active: "Active",
    inactive: "Inactive",
    all_locations: "All locations",
    request_leave: "Request leave",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    priority: "Priority",
    normal: "Normal",
    important: "Important",
    urgent: "Urgent",
    title: "Title",
    content: "Content",
    read_confirm: "Read",
    send: "Send",
    message: "Message",
    system_name: "System name",
    logo: "Logo",
    imprint: "Imprint",
    privacy: "Privacy",
    terms: "Terms",
    dark_mode: "Dark mode",
    light_mode: "Light mode",
    language: "Language",
    export_csv: "CSV export",
    export_xlsx: "Excel export",
    export_pdf: "PDF export",
    footer_text: "Made with",
    footer_by: "by",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "de");
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);
  const t = (key) => (dict[lang] && dict[lang][key]) || key;
  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
